import { makeAutoObservable } from "mobx";
import { deleteEthnics, getAllEthnics, getEthnicsById, pagingEthnics, saveEthnics } from "app/services/EthnicsService";
import { SearchObject } from "app/common/Model/SearchObject";
import { checkSearchObject } from "app/common/LocalFunction";
import { Ethnics } from "app/common/Model/Ethnics";
import { toast } from "react-toastify";

export default class EthnicsStore {
    listAllEthnics = [];
    searchEthnics = new SearchObject();
    pageEthnics = null;
    selectedEthnics = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteEthnics = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllEthnics = () => {
        if (this.listAllEthnics?.length === 0 || this.recentlyUpdated) {
            getAllEthnics()
                .then(({ data }) => {
                    this.listAllEthnics = data;
                    this.recentlyUpdated = false;
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Lấy dữ liệu dân tộc có lỗi");
                })
        }
    }

    pagingEthnics = () => {
        pagingEthnics(this.searchEthnics)
            .then(({ data }) => {
                this.pageEthnics = data;
            })
            .catch(error => {
                console.error(error);
                toast.error("Lấy dữ liệu dân tộc có lỗi");
            })
    }

    handleChangeFormSearch = (searchEthnics) => {
        this.searchEthnics = checkSearchObject(this.searchEthnics, searchEthnics);

        this.pagingEthnics();
    }

    handleOpenFormCreateOrEdit = (ethnicsId) => {
        if (Boolean(ethnicsId)) {
            getEthnicsById(ethnicsId)
                .then(({ data }) => {
                    this.selectedEthnics = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Lấy dữ liệu dân tộc có lỗi");
                })
        } else {
            this.selectedEthnics = new Ethnics();
            this.openFormCreateOrEdit = true;
        }
    }

    saveEthnics = (ethnics, { setSubmitting }) => {
        saveEthnics(ethnics)
            .then(() => {
                this.selectedEthnics = null;
                toast.success("Lưu dân tộc thành công!");
                this.handleClosePopup();
                this.pagingEthnics();
                this.recentlyUpdated = true;
            })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin dân tộc có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeleteEthnics = (ethnics) => {
        this.selectedEthnics = { id: ethnics?.id };
        this.openConfirmDeleteEthnics = true;
    }

    handleConfirmDeleteEthnics = () => deleteEthnics(this.selectedEthnics?.id)
        .then(() => {
            if (this.searchEthnics?.pageIndex > 1 && this.pageEthnics?.content?.length === 1) {
                this.searchEthnics.pageIndex -= 1;
            }
            toast.success("Xóa dân tộc thành công!")
            this.handleClosePopup();
            this.pagingEthnics();
            this.recentlyUpdated = true;
        })
        .catch(error => {
            console.error(error);
            toast.error("Xóa dân tộc có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteEthnics = false;
    }

    resetStore = () => {
        this.searchEthnics = new SearchObject();
        this.pageEthnics = null;
        this.selectedEthnics = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteEthnics = false;
    }
}
